import { spCandidateHistorySchedulingNcarbAuthHistoryLocs } from '../components/ncarb-authorization-history/ncarb-authorization-history.locs';
import { spCandidateHistorySchedulingNcarbExamAuthAddLocs } from '../components/ncarb-exam-auth-add/ncarb-exam-auth-add.locs';
import { spCandidateHistorySchedulingNcarbExamAuthEditLocs } from '../components/ncarb-exam-auth-edit/ncarb-exam-auth-edit.locs';
import { spCandidateHistorySchedulingNcarbExamAuthFormLocs } from '../components/ncarb-exam-auth-form/ncarb-exam-auth-form.locs';
import { spCandidateHistorySchedulingNcarbExamAuthRevokeLocs } from '../components/ncarb-exam-auth-revoke/ncarb-exam-auth-revoke.locs';
import { spCandidateHistorySchedulingNcarbAuthsLocs } from '../components/ncarb-exam-authorizations/ncarb-exam-authorizations.locs';
import { spCandidateHistorySchedulingNcarbLocs } from '../components/ncarb-scheduling/ncarb-scheduling.locs';

export const spNcarbAuthLocs = {
	...spCandidateHistorySchedulingNcarbAuthsLocs,
	...spCandidateHistorySchedulingNcarbAuthHistoryLocs,
	...spCandidateHistorySchedulingNcarbLocs,
	...spCandidateHistorySchedulingNcarbExamAuthAddLocs,
	...spCandidateHistorySchedulingNcarbExamAuthEditLocs,
	...spCandidateHistorySchedulingNcarbExamAuthRevokeLocs,
	...spCandidateHistorySchedulingNcarbExamAuthFormLocs,
};
